import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class FrogedService {

    loginEventName = 'froged-login-event';
    private events = {
        [this.loginEventName]: 'on_login'
    };

    loadUserFrogged(dataInfo: any, numberOfTries = 0): void {
        if (!(window as any).Froged('connected')) {
            if (numberOfTries < 10) {
                setTimeout(() => {
                    this.loadUserFrogged(dataInfo, ++numberOfTries);
                }, 1000);
            }

            return;
        }

        (window as any).Froged('set', {
            userId: dataInfo.tokenStaff,
            email: dataInfo.email,
            name: dataInfo.firstName,
            lastname: dataInfo.lastname,
            city: dataInfo.city,
            country: dataInfo.country,
            role: dataInfo.role,
            permission: dataInfo.permission,
            business_model: dataInfo.businessType,
            studio_model: dataInfo.businessCategory,
            centerSubcriptionType: dataInfo.centerSubcriptionType,
            account: {
                accountId: dataInfo.idCenter,
                name: dataInfo.centerName
            }
        });

        this.sendEvent(this.loginEventName);
    }

    sendEvent(eventName: string): void {

        if (this.isEventSent(eventName)) {
            return;
        }

        (window as any).Froged('track', this.events[eventName]);
        this.setEventAsSent(eventName);
    }

    isEventSent(eventName: string): boolean {
      const eventNameObject = sessionStorage.getItem(eventName);
        if(eventNameObject) {
          return JSON.parse(eventNameObject);
        } else {
          return false;
        }
    }

    private setEventAsSent(eventName: string): void {
        sessionStorage.setItem(eventName, 'true');
    }
}
